import { HOME } from '@/constants';

export const home = {
  [HOME.RANGE.MONTH]: 'Mese',
  [HOME.RANGE.TODAY]: 'Oggi',
  [HOME.RANGE.WEEK]: 'Settimana',
};
